<template>
  <div
    data-qa="lpu_phonebook_contact"
    class="phonebook-contact rounded-20 px-4"
    :class="{
      'bg-gray-40': isStriped,
      'd-flex flex-column ga-4 py-4': isMobile,
      'phonebook-contact--desktop d-flex align-center ga-5 py-7': !isMobile,
    }"
  >
    <div class="phonebook-contact__name text-body-1 text--text text-break min-w-0">
      {{ name }}
    </div>

    <div
      v-if="phoneLabel"
      class="phonebook-contact__phone d-flex align-center ga-2 flex-shrink-0"
    >
      <a
        v-if="rawHref"
        data-qa="lpu_phonebook_phone"
        class="d-flex align-center ga-2 text-subtitle-1 font-weight-medium text--text text-decoration-none"
        :href="rawHref"
      >
        <span
          class="ui-icon-phone-call bg-gray-80--text flex-shrink-0"
          :class="isMobile ? 'ui-icon-fz-medium' : 'ui-icon-fz-big'"
          aria-hidden="true"
        />
        {{ phoneLabel }}
      </a>
      <span
        v-else
        data-qa="lpu_phonebook_phone"
        class="d-flex align-center ga-2 text-subtitle-1 font-weight-medium text--text"
      >
        <span
          class="ui-icon-phone-call bg-gray-80--text flex-shrink-0"
          :class="isMobile ? 'ui-icon-fz-medium' : 'ui-icon-fz-big'"
          aria-hidden="true"
        />
        {{ phoneLabel }}
      </span>
      <a
        v-if="adminHref"
        :href="adminHref"
        class="adminka flex-shrink-0"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ tStatic('Править') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import useContextStore from 'src/store/useContextStore'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/index/types'
import type { GosPhoneSpeciality } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhonebook/types'
import getContactPhone from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhonebook/functions/getContactPhone'

const props = withDefaults(defineProps<{
  contact: GosPhoneSpeciality
  departmentName: string
  isStriped?: boolean
}>(), {
  isStriped: false,
})

const isMobile = useIsMobile()
const { context }: ContextStore = useContextStore()

const name = computed(() => tDynamic(props.contact, 'name') || props.departmentName)
const phoneView = computed(() => getContactPhone(
  props.contact.phone,
  props.contact.additional_number,
  context.request.country,
))
const phoneLabel = computed(() => {
  if (!phoneView.value.formatted) {
    return ''
  }

  if (!phoneView.value.additionalFormatted) {
    return phoneView.value.formatted
  }

  return `${phoneView.value.formatted} ${tStatic('доб.')} ${phoneView.value.additionalFormatted}`
})
const rawHref = computed(() => phoneView.value.rawHref)
const adminHref = computed(() => {
  const isStaff = Boolean(context.request.user.is_staff)

  if (isMobile.value || !isStaff || !props.contact.id) {
    return ''
  }

  return `/admin/doctors/gosphone/${props.contact.id}/`
})
</script>

<style lang="scss" scoped>
.phonebook-contact {
  &--desktop &__name {
    flex: 0 1 570px;
  }
}
</style>
